<template>
 <section class="scrollable padder">
  <section class="scrollable padder">
    <section  class="content">
        <div class="row">
          <div class="col-md-12">
            <div class="box">
              <div class="panel panel-default">
                <div class="panel-heading">
                  <i class="fa fa-list-ul"></i>
                  USER LIST
                </div>
                <div style="overflow-x:auto;" class="panel-body">
                  <table
                    width=""
                    class="table table-striped table-bordered table-hover"
                  >
                    <thead>
                      <tr>
                        <th width="5%">#</th>
                        <th width="25%">User Name</th>
                       <th width="40%">Details</th>
                       <th width="20%">User Role</th>
                        <th width="5%">Status</th>
                         <th width="5%">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      
                       <tr v-for="user in userList" :key="user.admin_user_id">
                        
                      
                         <td id="sino"></td>
                          <td>{{ user.first_name }} {{ user.last_name }}</td>
                           <td><span>Email : </span>{{ user.email }} <br>
                            <span>Contact No : </span>{{ user.contact_no }}</td>
                        <td>{{ user.user_role | userRole}}</td>
                        <td style="text-align:center">
                          <div class="switch" disabled readonly>
                            <label>
                              <input type="checkbox" checked readonly disabled/>
                              <span disabled readonly :class="user.admin_user_status? 'lever active': 'lever blocked'">{{user.admin_user_status ? 'Active': 'Disabled'}}</span>
                            </label>
                          </div>
                        </td>
                        <td>
                          <a
                            class="btn label-warning btn-xs"
                            style="float: left;display: block; width: 100%;"
                            v-on:click="$emit('edit-admin-user',user.admin_user_id)"
                            title="Edit"
                            ><i class="fa fa-edit"></i> Edit</a
                          >
                          <a
                            :class="user.admin_user_status ? 'btn label-danger btn-xs' : 'btn label-success btn-xs'"
                            style="float: left;display: block; width: 100%;margin-top: 3px;"
                            v-on:click="changeStatus(user.admin_user_id)"
                            ><i class="fa fa-pencil"></i> {{user.admin_user_status ? 'Disable' : 'Activate'}}</a
                          >

                         
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <!-- Show pagination links -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  </section>
 </section>
</template>

<script>
import api from "../api";

export default {
  name: "UserList",
  props: ["userid"],
  data() {
    return {
      userList: [],
          };
  },
  filters: {
    userRole: function (value) {
      if (value === 11) {
        return 'Admin'
      } else if(value ===12) {
        return 'Office Staff'
      } else {
        return ''
      }
    }
  },
  methods: {
    changeStatus: function(userid) {
        const formData = {
          "user-form": {
            admin_user_id: userid
          },
        };
        api
          .request("post", "GeneralApis/change_admin_user_status", formData)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              this.userList = data.userList;
            }
          });
      },
    getUserList: function() {
        const getuser = {
          filter: {
          },
        };
        api
          .request("post", "GeneralApis/get_admin_users", getuser)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              this.userList = data.userList;
            }
          });
      }
  },
  mounted() {
    this.getUserList();
  },
};
</script>

<style scoped>
.switch{
  width: 90px;
}
.switch .lever{
  font-size: 11px;
  line-height: 27px;
  width: 85px;
  color: #fff;
}
.switch .lever.active{
  padding-left: 10px;
  text-align: left;
}
.switch .lever.active::after{
  left:55px;
}
.switch .lever.blocked{
  padding-right: 7px;
  text-align: right;
  background-color: #dd4b39;
}
.switch .lever.blocked::after{
  left:1px;
}
</style>